import tables from './tables';
import utils from '../utils';

const getCountryCurrencies = async (token) => {
  try {
    const { data: countries } = await utils.getFromMikMakFirebaseService(
      `get/${tables.countryCurrency}`,
      token,
    );

    return countries;
  } catch (e) {
    throw `Error retrieving countries ${e.message}`;
  }
};

export default {
  getCountryCurrencies,
};
